// extracted by mini-css-extract-plugin
export default {"cls1":"common-cls1___c7e2cbfce9a1c661ed2","cls2":"common-cls2__cde852269e0cb2f82251 common-cls1___c7e2cbfce9a1c661ed2"};